/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Property } from '@app/shared/components/property/property.model';
import { ContactPerson } from '@app/shared/components/contact-person/contact-person.model';
import { Model } from '@app/shared/models/model.model';

export class SupplierCompany extends Model {
  id: number;
  type_id: number;
  name: string;
  selected: boolean;
  contact_persons: Array<ContactPerson>;
  properties: Array<Property>;
  abbreviation: string;

  deserialize(input: any): this {
    super.deserialize(input);
    return this;
  }
}
